import { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Download, X } from 'lucide-react';

export function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    const installedHandler = () => setIsInstalled(true);
    window.addEventListener('appinstalled', installedHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', installedHandler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setIsInstalled(true);
    }
    setDeferredPrompt(null);
  };

  if (isInstalled || dismissed || !deferredPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[340px] bg-[#1B4332] text-white rounded-xl p-4 shadow-2xl z-50 animate-slide-up flex items-center gap-3" data-testid="install-prompt">
      <div className="flex-1">
        <p className="font-semibold text-sm">Install Turf Farm</p>
        <p className="text-xs text-green-200">Add to home screen for quick access</p>
      </div>
      <Button size="sm" onClick={handleInstall} className="bg-white text-[#1B4332] hover:bg-green-100 text-xs font-semibold shrink-0" data-testid="install-btn">
        <Download className="h-3 w-3 mr-1" /> Install
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setDismissed(true)} className="h-7 w-7 p-0 text-white/60 hover:text-white shrink-0">
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
